import BorderedFilterItemCard from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterItemCard/BorderedFilterItemCard";
import { OnOffSwitchFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/OnOffSwitchFilter/OnOffSwitchFilter";
import { SwitchFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/SwitchFilterModel";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";

import { contactsFilterCategoryMap } from "../../types/contactsFilterCategory";

const createApplyContactFiltersFilter = (): SearchFilterInstance => {
    return {
        key: "useContactFiltersForCompanies",
        trackingName: "Apply Contact Filters For Companies",
        apiCategory: "contactsFilters",
        category: contactsFilterCategoryMap.contacts,
        visibility: "always-visible",
        filterCardLayout: "full-width",
        filter: new SwitchFilterModel({ label: leadsSearchFiltersI18nKeys.filterGroupLabel("applyContactFilters") }),
        filterResultView: OnOffSwitchFilter,
        filterCardView: BorderedFilterItemCard,
    };
};

export default createApplyContactFiltersFilter;
